import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

import { Container, Select, Option } from './styles'

export const DropDownPicker = ({ onUpdate, pickerItems, placeholder = 'Select', value = '' }) => {
  const handlePickerChange = (event) => {
    const { value: selectedValue } = event.target
    onUpdate(selectedValue)
  }

  const renderPickerItems = useMemo(
    () =>
      pickerItems.map((item) => {
        const { value: itemValue, label } = typeof item === 'object' ? item : { value: item, label: item }
        return (
          <Option key={itemValue} value={itemValue}>
            {label}
          </Option>
        )
      }),
    [pickerItems],
  )

  return (
    <Container>
      <Select value={value} onChange={handlePickerChange}>
        <Option value="" disabled>
          {placeholder}
        </Option>
        {renderPickerItems}
      </Select>
    </Container>
  )
}

DropDownPicker.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  pickerItems: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ]),
  ).isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
}

export default DropDownPicker
